var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"link-underline",class:{'is-border-hover': _vm.borderHover, 'is-center': _vm.center},attrs:{"to":_vm.to,"disabled":!_vm.to}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }